import React from 'react';
import { createPortal } from 'react-dom';

interface CheckerImageTooltipProps {
  searchedImage: { url: string; label: string } | null;
  foundImage: { url: string; label: string } | null;
  show: boolean;
  position: { x: number; y: number };
}

const SIZE = 220;
const PADDING = 12;
const VIEWPORT_MARGIN = 8;

const CheckerImageTooltip: React.FC<CheckerImageTooltipProps> = ({
  searchedImage,
  foundImage,
  show,
  position
}) => {
  if (!show) return null;
  const hasSearched = searchedImage?.url;
  const hasFound = foundImage?.url;
  if (!hasSearched && !hasFound) return null;

  const blockCount = (hasSearched ? 1 : 0) + (hasFound ? 1 : 0);
  const pad = 4;
  const width = blockCount * SIZE + pad * 2;
  const height = SIZE + 22 + pad * 2;
  let left = position.x + PADDING;
  let top = position.y - PADDING;
  left = Math.max(VIEWPORT_MARGIN, Math.min(window.innerWidth - width - VIEWPORT_MARGIN, left));
  top = Math.max(VIEWPORT_MARGIN, Math.min(window.innerHeight - height - VIEWPORT_MARGIN, top));

  const imgStyle: React.CSSProperties = {
    width: SIZE,
    height: SIZE,
    objectFit: 'cover',
    display: 'block',
    margin: 0,
    padding: 0
  };

  const content = (
    <div
      className="bg-dark border border-secondary rounded shadow-lg"
      style={{
        position: 'fixed',
        left,
        top,
        zIndex: 10000,
        pointerEvents: 'none',
        padding: pad,
        width,
        height,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 0
      }}
    >
      {hasSearched && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0, margin: 0, padding: 0 }}>
          <span className="small text-warning fw-bold" style={{ marginBottom: 2 }}>Искомый</span>
          <img src={searchedImage!.url} alt={searchedImage!.label} style={imgStyle} />
        </div>
      )}
      {hasFound && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0, margin: 0, padding: 0 }}>
          <span className="small text-success fw-bold" style={{ marginBottom: 2 }}>Найденный</span>
          <img src={foundImage!.url} alt={foundImage!.label} style={imgStyle} />
        </div>
      )}
    </div>
  );

  return typeof document !== 'undefined' && document.body ? createPortal(content, document.body) : null;
};

export default CheckerImageTooltip;
